      var frontendData = {};
      frontendData.enableCurrency = false;
      frontendData.ajax_search = true;
      frontendData.search_by_collection = false;
      var dataZoom = {};
      
      dataZoom.lightbox = false;
      
      dataZoom.position = 'inside';
      var cartData = {};
      cartData.ajax_cart_use = true;
      cartData.shopping_cart_action = 'popup';
      var wishlistData = {};
      var compareData = {};
      var obProductData = {};
      if (multi_language && translator.isLang2()) {
        obProductData.in_stock = window.lang2.products.product.in_stock;
        obProductData.out_of_stock = window.lang2.products.product.out_of_stock;
        obProductData.add_to_cart = window.lang2.products.product.add_to_cart;
        obProductData.sold_out = window.lang2.products.product.sold_out;
        cartData.removeItemLabel = window.lang2.cart.header.remove_this_item;
        cartData.totalLabel = window.lang2.cart.header.total;
        cartData.totalNumb = window.lang2.cart.header.total_numb;
        cartData.noItemLabel = window.lang2.cart.header.no_item;
        cartData.buttonViewCart = window.lang2.cart.header.view_cart;
        cartData.buttonCheckout = window.lang2.cart.header.checkout;
        window.inventory_text = {
          in_stock: window.lang2.products.product.in_stock,
          many_in_stock: window.lang2.products.product.many_in_stock,
          out_of_stock: window.lang2.products.product.out_of_stock,
          add_to_cart: window.lang2.products.product.add_to_cart,
          sold_out: window.lang2.products.product.sold_out
        };
        window.date_text = {
          year_text: window.lang2.general.date.year_text,
          month_text: window.lang2.general.date.month_text,
          week_text: window.lang2.general.date.week_text,
          day_text: window.lang2.general.date.day_text,
          year_singular_text: window.lang2.general.date.year_singular_text,
          month_singular_text: window.lang2.general.date.month_singular_text,
          week_singular_text: window.lang2.general.date.week_singular_text,
          day_singular_text: window.lang2.general.date.day_singular_text,
          hour_text: window.lang2.general.date.hour_text,
          min_text: window.lang2.general.date.min_text,
          sec_text: window.lang2.general.date.sec_text,
          hour_singular_text: window.lang2.general.date.hour_singular_text,
          min_singular_text: window.lang2.general.date.min_singular_text,
          sec_singular_text: window.lang2.general.date.sec_singular_text
        };
        wishlistData.wishlist = window.lang2.wish_list.general.wishlist;
        wishlistData.product = window.lang2.wish_list.general.product;
        wishlistData.quantity = window.lang2.wish_list.general.quantity;
        wishlistData.options = window.lang2.wish_list.general.options;
        wishlistData.remove = window.lang2.wish_list.general.remove;
        wishlistData.no_item = window.lang2.wish_list.general.no_item;
        wishlistData.item_exist = window.lang2.wish_list.general.item_exist;
        wishlistData.item_added = window.lang2.wish_list.general.item_added;
        compareData.compare = window.lang2.compare_list.general.wishlist;
        compareData.product = window.lang2.compare_list.general.product;
        compareData.quantity = window.lang2.compare_list.general.quantity;
        compareData.options = window.lang2.compare_list.general.options;
        compareData.remove = window.lang2.compare_list.general.remove;
        compareData.no_item = window.lang2.compare_list.general.no_item;
        compareData.item_exist = window.lang2.compare_list.general.item_exist;
        compareData.item_added = window.lang2.compare_list.general.item_added;
      } else {
        obProductData.in_stock = 'In Stock';
        obProductData.out_of_stock = 'Out Of Stock';
        obProductData.add_to_cart = 'Add To Order';
        obProductData.sold_out = 'Request Quote';
        cartData.removeItemLabel = 'Remove item';
        cartData.totalLabel = 'Total:';
        cartData.totalNumb = 'item(s)';
        cartData.noItemLabel = 'You have no items in your shopping cart.';
        cartData.buttonViewCart = 'View Order';
        cartData.buttonCheckout = 'Checkout';
        window.inventory_text = {
          in_stock: "In Stock",
          many_in_stock: "Many In Stock",
          out_of_stock: "Out Of Stock",
          add_to_cart: "Add To Order",
          sold_out: "Request Quote"
        };

        window.date_text = {
          year_text: "years",
          month_text: "months",
          week_text: "weeks",
          day_text: "days",
          year_singular_text: "year",
          month_singular_text: "month",
          week_singular_text: "week",
          day_singular_text: "day",
          hour_text: "Hours",
          min_text: "Mins",
          sec_text: "Secs",
          hour_singular_text: "Hour",
          min_singular_text: "Min",
          sec_singular_text: "Sec"
        };
        wishlistData.wishlist = 'Wishlist';
        wishlistData.product = 'Product';
        wishlistData.quantity = 'Quantity';
        wishlistData.options = 'Options';
        wishlistData.remove = 'has removed from wishlist';
        wishlistData.no_item = 'There is no items in wishlist box';
        wishlistData.item_exist = 'is exist in wishlist';
        wishlistData.item_added = 'has added to wishlist successful';
        compareData.compare = 'Comparing box';
        compareData.product = 'Product';
        compareData.quantity = 'Quantity';
        compareData.options = 'Options';
        compareData.remove = 'has removed from comparing box';
        compareData.no_item = 'There is no items in comparing box';
        compareData.item_exist = 'is exist in compare';
        compareData.item_added = 'has added to comparing box successful';
      }
